import React, { useEffect } from 'react'
import { Select } from 'antd'
import { useListPermissionsQuery } from '../redux/Api/UserManagment/uMPermissionsApiSlice'
import { toast } from 'react-toastify'

const PermissionsDropdown = ({
  onChange,
  onBlur,
  value,
  multi = true,
  name = 'user_permissions'
}) => {
  const { data: permissions, isLoading, error } = useListPermissionsQuery({
    fields: ['id', 'name'].join(','),
    page: '*',
    ordering: '-id'
  })
  let options = []
  if (permissions) {
    options = permissions?.results?.map(item => {
      return {
        label: item.name,
        value: item.id
      }
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])
  return (
    <div className=' mb-3'>
      <label className=''>permissions</label>
      <br />
      <Select
        mode={multi ? 'multiple' : ''}
        allowClear
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        loading={isLoading}
        placeholder='Please select'
        onBlur={onBlur}
        value={value}
        onChange={e => onChange(name, e)}
        options={options}
      />
    </div>
  )
}

export default PermissionsDropdown
